module.exports = __webpack_public_path__ + "fa-regular-400.woff?d1d7e3b4c219fde0f7376c6facfd7149";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-regular-400.woff
// module id = 1453
// module chunks = 0